// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initMessageTool = function () {
    (function (_super) {
        coffeeExtends(MessageTool, _super);
        function MessageTool() {
            return MessageTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(MessageTool, 'message');
        MessageTool.label = 'Insert Message';
        MessageTool.icon = 'message';
        MessageTool.tagName = 'msg';
        MessageTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const messageHtml = `<${MessageTool.tagName} contenteditable="false">UPDATE MESSAGE</${
                MessageTool.tagName
            }>`;
            // http://getcontenttools.com/api/html-string
            element.content = tip.concat(
                new window.HTMLString.String(' ', true),
                messageHtml,
                new window.HTMLString.String(' ', true),
                tail,
                false
            );
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 12, cursor + 12);
            element.selection(selection);
            ContentTools.Tools.LineBreak.dispatchEditorEvent('tool-applied', {
                name: 'CKP_MessageTool',
                transform: true
            });
            callback(true);
        };
        return MessageTool;
    })(ContentTools.Tools.LineBreak);
};
